:host {
  display: block;
  padding: 0 0 0 #{calc(1rem * (var(--sy-blog-summary-level, 0)))};

  a {
    color: inherit;
    text-decoration: unset;
  }
}
